module.exports = __webpack_public_path__ + "img/check.37862a8d.svg";